import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';
import { InstituteCommonDetailsV2Response } from '../../../models/institute/instituteCommonDetailsV2Response';
import { DialogModule } from 'primeng/dialog';

export interface InstituteAlumniItem {
  id: string;
  firstName: string;
  lastName?: string | null;
  descriptionOrUrl?: string | null;
  photoUrl?: string | null;
}

@Component({
  selector: 'app-institute-detail-alumni',
  standalone: true,
  imports: [CommonModule, DialogModule],
  templateUrl: './institute-detail-alumni.component.html',
  styleUrl: './institute-detail-alumni.component.scss'
})
export class InstituteDetailAlumniComponent implements OnChanges {

  @Input() institute: InstituteCommonDetailsV2Response | undefined;

  alumniList: InstituteAlumniItem[] = [];
  isLoading = false;
  showAll = false;
  initialCount = 6;
  
  // Modal State
  displayAlumniDialog = false;
  selectedAlumni: InstituteAlumniItem | null = null;

  ngOnChanges(): void {
    if (this.institute?.alumni) {
      this.loadAlumni();
    }
  }

  showAlumniDetails(alumni: InstituteAlumniItem): void {
    this.selectedAlumni = alumni;
    this.displayAlumniDialog = true;
  }

  loadAlumni(): void {
    if (!this.institute?.alumni) {
      this.alumniList = [];
      return;
    }

    this.isLoading = true;
    const alumniData = this.institute.alumni;
    const combined: InstituteAlumniItem[] = [];

    // Helper to map API items to the local interface
    const mapFn = (item: any) => ({
      id: item.id || (Math.random().toString(36).substring(7)),
      firstName: item.firstName || '',
      lastName: item.lastName || '',
      descriptionOrUrl: item.url || item.description || item.descriptionOrUrl,
      photoUrl: item.profileImage || item.imagePreview || item.photoUrl
    });

    if (alumniData.influentialAlumni) {
      combined.push(...alumniData.influentialAlumni.map(mapFn));
    }
    if (alumniData.alumniInLeadershipRoles) {
      combined.push(...alumniData.alumniInLeadershipRoles.map(mapFn));
    }
    if (alumniData.startupFoundersFromCollege) {
      combined.push(...alumniData.startupFoundersFromCollege.map(mapFn));
    }

    // Deduplicate by name if necessary, or just use as is
    this.alumniList = combined;
    this.isLoading = false;
  }

  get visibleAlumni(): InstituteAlumniItem[] {
    return this.showAll ? this.alumniList : this.alumniList.slice(0, this.initialCount);
  }

  toggleView(): void {
    this.showAll = !this.showAll;
  }

  trackById(_: number, item: InstituteAlumniItem): string {
    return item.id;
  }

  isUrl(value: string): boolean {
    return /^(https?:\/\/|www\.)/i.test(value);
  }

  ensureHttp(url: string): string {
    return /^https?:\/\//i.test(url) ? url : 'https://' + url;
  }

  onImgError(event: Event): void {
    (event.target as HTMLImageElement).src = 'assets/images/logo-placeholder.png';
  }
}
